// extracted by mini-css-extract-plugin
export default {"statusFailed":"RevenuePayoutsTable_statusFailed__R20ua","debitLabel":"RevenuePayoutsTable_debitLabel__LC63L"};